export enum StaffStatus {
  Online = 'Online',
  Offline = 'Offline',
  CreatePassword = 'CreatePassword',
  Deactivated = 'Deactivated',
}
